import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../services/store';
import {
  fetchNotificationsForCurrentMember,
  NotificationModel,
  selectAllNotifications,
} from '../../../../services/store/modules/notifications';

const useNotifications = (): [
  NotificationModel[],
  boolean,
  string | undefined,
  () => Promise<void>,
  number | undefined,
] => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | undefined>();
  const notifications = useSelector(selectAllNotifications);

  const unreadCount = notifications.filter(
    (notification) =>
      notification.data?.requiredNotification && !notification.read,
  ).length;

  const fetchNotifications = useCallback(async () => {
    try {
      setError(undefined);
      setLoading(true);
      await dispatch(fetchNotificationsForCurrentMember()).unwrap();
      setLoading(false);
    } catch (e: any) {
      setError('Unable to load notifications');
    }
  }, [dispatch]);

  useEffect(() => {
    fetchNotifications();
  }, [dispatch, fetchNotifications]);

  return [notifications, loading, error, fetchNotifications, unreadCount];
};

export default useNotifications;
